module.exports = __webpack_public_path__ + "static/media/SP_top_ranking_product.613d2cb6.jpg";